import PropTypes from 'prop-types';

import './DeckListPanel.css';

import { useDeck } from '../../../hook/useDeck';
import { buildClass } from '../../../libs/classes';
import WorkspacePanel, { WorkspacePanelHead } from '../../../components/WorkspacePanel/WorkspacePanel';
import DropDownMenu, { dropDownTemplate } from '../../../components/DropDownMenu/DropDownMenu';
import MenuItem from '../../../components/DropDownMenu/MenuItem/MenuItem';
import SimpleButton, { ButtonTypes } from '../../../components/SimpleComponents/SimpleButton';

/**
 * Deck List Component. Allows add, modify, delete decks
 * @component
 */
const DeckListPanel = ({ onSelectDeck, onAddDeckReq, onModifyDeckReq, onDeleteDeckReq }) => {
	const { decks, activeDeck } = useDeck();

	return (
		<WorkspacePanel className="decks-list noselect">
			<WorkspacePanelHead title="Decks">
				<SimpleButton
					title="Add a new deck"
					type={ButtonTypes.DEFAULT}
					value="Add New"
					onClick={onAddDeckReq}
				/>
			</WorkspacePanelHead>

			<div className="content scrollable">
				{(Object.keys(decks).length &&
					Object.keys(decks).map((key) => (
						<div
							className={buildClass('deck').add(activeDeck && decks[key].id === activeDeck.id, 'active')}
							key={decks[key].id}
							onClick={() => onSelectDeck(decks[key])}
						>
							<div className="name">{decks[key].name}</div>
							<DropDownMenu className="deck-context" template={dropDownTemplate.small_left}>
								<MenuItem
									text="Modify"
									onClick={() => {
										onModifyDeckReq(decks[key]);
									}}
								/>
								<MenuItem
									text="Delete"
									onClick={() => {
										onDeleteDeckReq(decks[key]);
									}}
								/>
							</DropDownMenu>
						</div>
					))) || <div className="no-decks">Decks haven&apos;t been added yet</div>}
			</div>
		</WorkspacePanel>
	);
};

DeckListPanel.propTypes = {
	// Callback function on select storage
	onSelectDeck: PropTypes.func.isRequired,
	// Callback function on add deck request
	onAddDeckReq: PropTypes.func.isRequired,
	// Callback function on modify deck request
	onModifyDeckReq: PropTypes.func.isRequired,
	// Callback function on delete deck request
	onDeleteDeckReq: PropTypes.func.isRequired,
};

export default DeckListPanel;
